/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import {
    Icon,
    Label,
    DatePicker,
    FlexRow,
    FlexCol,
    Button,
    Select,
    TextField,
    localToday,
} from 'sarsaparilla';
import { gnoment, gnomentToCalendarDate, calendarDateToGnoment } from 'shared-ui/gnoment';

const MANUAL_ENTRY = 'MANUAL_ENTRY';

export default class CommercialGuideItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            guide: props.guide,
            manualEntry: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.guide.license_number === this.props.guide.license_number) return;

        this.setState({ guide: this.props.guide });

        if (
            !this.props.guide.first_name &&
            !this.props.guide.last_name &&
            !this.props.guide.license_number
        ) {
            this.setState({
                manualEntry: false,
            });
            return;
        }

        if (
            typeof this.props.allGuides.find(
                (guide) => guide.license_number === this.props.guide.license_number
            ) === 'undefined'
        ) {
            this.setState({
                manualEntry: true,
            });
        } else {
            this.setState({
                manualEntry: false,
            });
        }
    }

    createID = (key) => `${key}-${this.props.index}`;

    handleGuideSelect = (event) => {
        const guideId = get(event, 'target.value', '');
        if (guideId === MANUAL_ENTRY) {
            this.setState({ manualEntry: true });
            this.props.handleGuideChange(this.props.index, { license_number: ' ' });
            return;
        }
        const guide = this.props.allGuides.find(
            (thisGuide) => thisGuide.license_number === guideId
        );
        this.props.handleGuideChange(this.props.index, guide);
    };

    handleGuideRemove = () => this.props.handleGuideRemove(this.props.index);

    handleGuideInputDataChange = ({ target: { name, value } }) => {
        let guide = {};
        let mappedGuide = {};
        switch (name) {
            case 'guide-license-number':
                mappedGuide = this.props.allGuides.find(
                    (thisGuide) => thisGuide.license_number === value
                );

                guide = { ...this.state.guide, license_number: value };

                if (mappedGuide) {
                    guide = {
                        ...this.state.guide,
                        employee_id: mappedGuide.employee_id,
                        license_number: value,
                        first_name: mappedGuide.first_name,
                        last_name: mappedGuide.last_name,
                        license_expiration_date: mappedGuide.license_expiration_date,
                    };
                }

                this.setState({ guide });
                this.props.handleGuideChange(this.props.index, guide);
                break;
            case 'guide-first-name':
                mappedGuide = this.props.allGuides.find(
                    (thisGuide) => thisGuide.first_name === value
                );

                guide = { ...this.state.guide, first_name: value };

                if (mappedGuide) {
                    guide = {
                        ...this.state.guide,
                        employee_id: mappedGuide.employee_id,
                        license_number: mappedGuide.license_number,
                        first_name: value,
                        last_name: mappedGuide.last_name,
                        license_expiration_date: mappedGuide.license_expiration_date,
                    };
                }

                this.setState({ guide });
                this.props.handleGuideChange(this.props.index, guide);
                break;
            case 'guide-last-name':
                mappedGuide = this.props.allGuides.find(
                    (thisGuide) => thisGuide.last_name === value
                );

                guide = { ...this.state.guide, last_name: value };

                if (mappedGuide) {
                    guide = {
                        ...this.state.guide,
                        employee_id: mappedGuide.employee_id,
                        license_number: mappedGuide.license_number,
                        first_name: mappedGuide.first_name,
                        last_name: value,
                        license_expiration_date: mappedGuide.license_expiration_date,
                    };
                }

                this.setState({ guide });
                this.props.handleGuideChange(this.props.index, guide);
                break;
            default:
                break;
        }
    };

    handleGuideDateChange = (date) => {
        const guide = {
            ...this.state.guide,
            license_expiration_date: date ? date.format('YYYY-MM-DDTHH:mm:ssZ') : null,
        };
        this.setState({ guide });
        this.props.handleGuideChange(this.props.index, guide);
    };

    isDisabled = () => this.props.isDisabled && this.props.index === 0;

    renderGuideDropdown(guide) {
        const guideOpts = this.props.allGuides.map((g) => {
            return {
                label: `${g.first_name} ${g.last_name}`,
                value: `${g.license_number}`,
            };
        });

        guideOpts.unshift({
            label: 'Manual Entry ...',
            value: MANUAL_ENTRY,
        });
        return (
            <FlexCol md={6}>
                <div className="rec-form-item-wrap">
                    <Select
                        className="rec-time-timezone-select"
                        disabled={this.isDisabled()}
                        id={this.createID('guide-select')}
                        isLabelVisible={this.props.index === 0}
                        label="Employee / Guide"
                        name="guide-select"
                        onChange={this.handleGuideSelect}
                        options={guideOpts}
                        value={guide.license_number || ''}
                    />
                </div>
            </FlexCol>
        );
    }

    renderManualEntryFields(guide) {
        return (
            <FlexCol md={6}>
                <FlexRow>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                id={this.createID('guide-first-name')}
                                isLabelVisible={this.props.index === 0}
                                label="Employee / Guide"
                                name="guide-first-name"
                                onChange={this.handleGuideInputDataChange}
                                placeholder="First Name"
                                value={guide.first_name || ''}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={6}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                id={this.createID('guide-last-name')}
                                isLabelVisible={this.props.index === 0}
                                label="Guide last name"
                                name="guide-last-name"
                                onChange={this.handleGuideInputDataChange}
                                placeholder="Last Name"
                                value={guide.last_name || ''}
                            />
                        </div>
                    </FlexCol>
                </FlexRow>
            </FlexCol>
        );
    }

    render() {
        const { guide } = this.state;

        return (
            <div
                aria-label={`Employee / Guide # ${this.props.index + 1}`}
                className="per-form-group-item"
            >
                <FlexRow>
                    {this.state.manualEntry
                        ? this.renderManualEntryFields(guide)
                        : this.renderGuideDropdown(guide)}
                    <FlexCol md={2}>
                        <div className="rec-form-item-wrap">
                            <TextField
                                id={this.createID('guide-license-number')}
                                isLabelVisible={this.props.index === 0}
                                label="Guide ID #"
                                name="guide-license-number"
                                onChange={this.handleGuideInputDataChange}
                                value={guide.license_number || ''}
                            />
                        </div>
                    </FlexCol>
                    <FlexCol md={2}>
                        {this.props.index === 0 && (
                            <Label
                                className="pb-half"
                                htmlFor={this.createID('expiration-date')}
                            >
                                Expiration Date{' '}
                            </Label>
                        )}

                        <DatePicker
                            id={this.createID('expiration-date')}
                            isLabelVisible={false}
                            label={'Expiration Date'}
                            numVisibleMonths={1}
                            value={gnomentToCalendarDate(
                                gnoment(guide.license_expiration_date).utc()
                            )}
                            onChange={(day) =>
                                this.handleGuideDateChange(calendarDateToGnoment(day))
                            }
                            minValue={localToday}
                            isRequired
                        />
                    </FlexCol>
                    <FlexCol md={2} alignSelf="end">
                        {!this.props.disableRemove && (
                            <div className="per-form-group-item-remove">
                                <Button
                                    appearance="subtle-danger"
                                    iconBeforeElement={<Icon iconName="delete" />}
                                    onClick={this.handleGuideRemove}
                                    screenReaderTextAfter={`guide # ${this.props.index + 1}`}
                                >
                                    Remove
                                </Button>
                            </div>
                        )}
                    </FlexCol>
                </FlexRow>
            </div>
        );
    }
}

CommercialGuideItem.propTypes = {
    handleGuideChange: PropTypes.func,
    handleGuideRemove: PropTypes.func,
    index: PropTypes.number,
    guide: PropTypes.shape({
        employee_id: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
        license_number: PropTypes.string,
        license_expiration_date: PropTypes.string,
        company_id: PropTypes.string,
    }),
    allGuides: PropTypes.array,
    isDisabled: PropTypes.bool,
    disableRemove: PropTypes.bool,
};

CommercialGuideItem.defaultProps = {
    isDisabled: false,
    disableRemove: false,
};
